import './main.less';

import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

import { enum as permissions } from '../../../../../enums/admin-permissions';

const navigation = [
	{
		href: '/mailings-new/manual-mailings',
		name: 'Manual mailings',
		permission: null
	},
	{
		href: '/mailings-new/triggered-mailings',
		name: 'Triggered mailings',
		permission: null
	},
	{
		href: '/mailings-new/images',
		name: 'Images',
		permission: null
	}
];

export default Main => withPageContainer(withIntl(Main), {
	name: 'Mailings',
	tabs: navigation,
	permission: permissions.mailingsList
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/mailings-new/wrap-main.js